import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteShopLocation(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("delete", "/shops/{shopId}/locations/{shopLocationId}");
  const invalidateShop = useInvalidateShop(shop.id);

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (shopLocationId: string) => {
      return mutation.mutateAsync({ params: { path: { shopId: shop.id, shopLocationId } } });
    },
  });
}
